'use client'

import { Wifi, Cpu, Radio, Gauge } from 'lucide-react'
import ServicePageTemplate from '@/components/ServicePageTemplate'

export default function IoTEmbeddedPage() {
  return (
    <ServicePageTemplate
      title="IoT &"
      titleHighlight="Embedded"
      description="Internet of Things solutions, embedded systems, and smart device applications connecting physical and digital worlds."
      accentColor="from-teal-500 to-emerald-600"
      stats={[
        { value: '40+', label: 'IoT Projects' },
        { value: '1M+', label: 'Devices Connected' },
        { value: '99.5%', label: 'Connectivity' },
        { value: '50+', label: 'Protocols Supported' }
      ]}
      services={[
        { icon: <Wifi className="w-6 h-6" />, title: 'IoT Solutions', description: 'End-to-end IoT solutions from sensors to cloud.', features: ['Sensor Integration', 'Data Collection', 'Cloud Connectivity', 'Edge Computing'] },
        { icon: <Cpu className="w-6 h-6" />, title: 'Embedded Systems', description: 'Custom firmware and embedded software development.', features: ['Firmware Development', 'RTOS Integration', 'Power Optimization', 'Hardware Abstraction'] },
        { icon: <Radio className="w-6 h-6" />, title: 'Smart Devices', description: 'Connected smart device applications and dashboards.', features: ['Mobile Companion Apps', 'Real-time Dashboards', 'OTA Updates', 'Device Management'] },
        { icon: <Gauge className="w-6 h-6" />, title: 'Industrial IoT', description: 'Industrial automation and monitoring systems.', features: ['Predictive Maintenance', 'SCADA Integration', 'Process Automation', 'Asset Tracking'] },
      ]}
      technologies={[
        { name: 'Arduino', category: 'Platform' }, { name: 'Raspberry Pi', category: 'Platform' },
        { name: 'MQTT', category: 'Protocol' }, { name: 'LoRa', category: 'Communication' },
        { name: 'Zigbee', category: 'Protocol' }, { name: 'AWS IoT', category: 'Cloud' },
        { name: 'FreeRTOS', category: 'OS' }, { name: 'BLE', category: 'Wireless' },
      ]}
      process={[
        { step: '01', title: 'Requirements', description: 'Define use case, connectivity, and device specifications.' },
        { step: '02', title: 'Hardware Design', description: 'PCB design, sensor selection, and prototyping.' },
        { step: '03', title: 'Firmware Dev', description: 'Embedded software with communication protocols.' },
        { step: '04', title: 'Cloud Integration', description: 'IoT platform setup and data pipeline.' },
        { step: '05', title: 'Application Layer', description: 'Dashboards, mobile apps, and analytics.' },
        { step: '06', title: 'Deployment', description: 'Field testing, certification, and mass production.' },
      ]}
    />
  )
}
